import { render, staticRenderFns } from "./VacinadosCovid.vue?vue&type=template&id=1d7d2f4b&"
import script from "./VacinadosCovid.vue?vue&type=script&lang=js&"
export * from "./VacinadosCovid.vue?vue&type=script&lang=js&"
import style0 from "./VacinadosCovid.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports